export default __webpack_public_path__ + "static/media/tiger_8.d0cec00e.mp3";